export const COMPONENT_NAME = 'Settings.PackageDetails';
